module.exports = __webpack_public_path__ + "img/en_redpacket.6100b84e.png";